/**
 * This is a helper to be used when you are in a scenario where you want to explicitly
 * support NULL as your Prop.
 *
 * For example if your prop allows Null OR a Boolean value you will define the PropType as
 * allowNull(PropTypes.bool).
 *
 * This is typically only needed when its state is both managed/unmanaged.
 * I.e. when u try allow a prop to update a component's internal state (anti-pattern),
 * something that we should be avoiding and fixing in the library.
 *
 * FIXME: This can probably be removed once https://origindd.atlassian.net/browse/SAT-278 is done.
 */
export var allowNull = function allowNull(wrappedPropTypes) {
  return function (object, key, componentName) {
    if (object[key] === null) return null;

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return wrappedPropTypes.apply(void 0, [object, key, componentName].concat(rest));
  };
};